import React from "react";

import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import img from "../../../assets/images/conheca-seu-parceiro.png"
export default function ConhecaSeuParceiro() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0  sectionInit ">
        <div className="c-init  ">
          <div className="c-init__text col-6  d-flex flex-column sect">
            <p className="fw-bolder text-decoration-underline text-uppercase">
              Conheça Seu Parceiro (KYP – Know Your Partner)
            </p>

            <p>
              Procedimento elaborado por Marco Dulgheroff Novais (Jurídico) e
              autorizada a publicação pelo Diretor Elson do Nascimento Gusmão,
              para relacionamento e operacionalização dos Correspondentes
              Cambiais vinculados à OM DTVM.
            </p>
          </div>
          <div className="col-6 c-init__images">
             <img src={img} className="images" alt="politica-privacidade"></img>
          </div>
        </div>

        <section>
          <h3>Sumário</h3>
          <ol>
            <li>
              <a href="#sec1">Conformidade e Âmbito de Aplicação</a>
            </li>
            <li>
              <a href="#sec2">Validade e Disponibilização</a>
            </li>
            <li>
              <a href="#sec3">Objetivo deste Procedimento</a>
            </li>
            <li>
              <a href="#sec4">Programa de Prevenção à Lavagem de Dinheiro</a>
            </li>
            <li>
              <a href="#sec5">Dos Princípios</a>
            </li>
            <li>
              <a href="#sec6">Das Diretrizes</a>
            </li>
            <li>
              <a href="#sec7">Papéis e Responsabilidades</a>
            </li>
            <li>
              <a href="#sec8">Definição de Parceiro</a>
            </li>
            <li>
              <a href="#sec9">Documentos Solicitados</a>
            </li>
            <li>
              <a href="#sec10">Critérios da classificação de risco</a>
            </li>
            <li>
              <a href="#sec11">Especificidades para cada grupo de risco</a>
            </li>
            <li>
              <a href="#sec12">Sistemas Utilizados</a>
            </li>
            <li>
              <a href="#sec13">Guarda de Documentos</a>
            </li>
            <li>
              <a href="#sec14">Sanções Administrativas</a>
            </li>
          </ol>
        </section>

        <section className="mt-5 border p-5" id="sec1">
          <p>
            <ul>
              <li className="fw-bolder text-decoration-underline text-uppercase  mb-3 list-unstyled">
                1. Conformidade e Âmbito de Aplicação
              </li>
              <li className="list-unstyled">
                <p>
                  Este procedimento está em conformidade com a Lei Nº 9.613
                  <CustomTooltip
                    text='Dispõe sobre os crimes de "lavagem" ou ocultação de bens, direitos e valores; a prevenção da utilização do sistema financeiro para os ilícitos previstos nesta Lei; cria o Conselho de Controle de Atividades Financeiras - COAF, e dá outras providências.'
                    title="¹"
                  />
                  ,de 3 de março de 1998 alterada pela Lei Nº 12.683
                  <CustomTooltip
                    title="²"
                    text="Altera a Lei nº 9.613, de 3 de março de 1998, para tornar mais eficiente a persecução penal dos crimes de lavagem de dinheiro."
                  />
                  de 09 de julho de 2012; Lei nº 12.844
                  <CustomTooltip
                    title="³"
                    text="Amplia o valor do Benefício Garantia-Safra para a safra de 2011/2012; amplia o Auxílio Emergencial Financeiro, de que trata a Lei nº 10.954, de 29 de setembro de 2004, relativo aos desastres ocorridos em 2012; autoriza a distribuição de milho para venda a pequenos criadores, nos termos que especifica; institui medidas de estímulo à liquidação ou regularização de dívidas originárias de operações de crédito rural; altera as Leis nºs 10.865, de 30 de abril de 2004, e 12.546, de 14 de dezembro de 2011, para prorrogar o Regime Especial de Reintegração de Valores Tributários para as Empresas Exportadoras - REINTEGRA e para alterar o regime de desoneração da folha de pagamentos, 11.774, de 17 de setembro de 2008, 10.931, de 2 de agosto de 2004, 12.431, de 24 de junho de 2011, 12.249, de 11 de junho de 2010, 9.430, de 27 de dezembro de 1996, 10.522, de 19 de julho de 2002, 8.218, de 29 de agosto de 1991, 10.833, de 29 de dezembro de 2003, 9.393, de 19 de dezembro de 1996, 12.783, de 11 de janeiro de 2013, 12.715, de 17 de setembro de 2012, 11.727, de 23 de junho de 2008, 12.468, de 26 de agosto de 2011, 10.150, de 21 de dezembro de 2000, 12.512, de 14 de outubro de 2011, 9.718, de 27 de novembro de 1998, 10.925, de 23 de julho de 2004, 11.775, de 17 de setembro de 2008, e 12.716, de 21 de setembro de 2012, a Medida Provisória nº 2.158-35, de 24 de agosto de 2001, e o Decreto nº 70.235, de 6 de março de 1972; dispõe sobre a comprovação de regularidade fiscal pelo contribuinte; regula a compra, venda e transporte de ouro; e dá outras providências."
                  />
                  , de 19 de julho de 2013; Lei Nº 13.260
                  <CustomTooltip
                    title="⁴"
                    text="Regulamenta o disposto no inciso XLIII do art. 5º da Constituição Federal, disciplinando o terrorismo, tratando de disposições investigatórias e processuais e reformulando o conceito de organização terrorista; e altera as Leis n º 7.960, de 21 de dezembro de 1989, e 12.850, de 2 de agosto de 2013."
                  />
                  , de 16 de março de 2016; Lei Nº 13.810
                  <CustomTooltip
                    title="⁵"
                    text="Dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados; e revoga a Lei nº 13.170, de 16 de outubro de 2015."
                  />
                  , de 8 de março de 2019; Circular BCB N° 3.978
                  <CustomTooltip
                    title="⁶"
                    text="Dispõe sobre a política, os procedimentos e os controles internos a serem adotados pelas instituições autorizadas a funcionar pelo Banco Central do Brasil visando à prevenção da utilização do sistema financeiro para a prática dos crimes de “lavagem” ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento do terrorismo, previsto na Lei nº 13.260, de 16 de março de 2016."
                  />
                  , de 23 de janeiro de 2020; Carta Circular BCB Nº 4.001
                  <CustomTooltip
                    title="⁷"
                    text='Divulga relação de operações e situações que podem configurar indícios de ocorrência dos crimes de "lavagem" ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento ao terrorismo, previstos na Lei nº 13.260, de 16 de março de 2016, passíveis de comunicação ao Conselho de Controle de Atividades Financeiras (Coaf).'
                  />
                  , de 29 de janeiro de 2020; Resolução CMN Nº 4.968
                  <CustomTooltip
                    title="⁸"
                    text="Dispõe sobre os sistemas de controles internos das instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil."
                  />
                  , de 25 de novembro de 2021; Resolução BCB Nº 44
                  <CustomTooltip
                    title="⁹"
                    text="Estabelece procedimentos para a execução pelas instituições autorizadas a funcionar pelo Banco Central do Brasil das medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados."
                  />{" "}
                  , de 24 de novembro de 2020, Instrução Normativa BCB Nº 262
                  <CustomTooltip
                    text="Especifica e esclarece aspectos operacionais dos procedimentos estabelecidos na Resolução BCB nº 44, de 24 de novembro de 2020, para a execução de medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, bem como a designação nacional de pessoas investigadas ou acusadas de terrorismo, seu financiamento ou atos correlacionados."
                    title="¹⁰"
                  />
                  , de 31 de março de 2022, Resolução ANM Nº 129
                  <CustomTooltip
                    title="¹¹"
                    text="Dispõe sobre cumprimento dos deveres de prevenção à lavagem de dinheiro e ao financiamento do terrorismo e da proliferação de armas de destruição em massa - PLD/FTP, legalmente atribuídos na forma dos arts. 10 e 11 da Lei nº 9.613, de 3 de março de 1998."
                  />
                  , de 23 de fevereiro de 2023 e dispõe sobre os princípios e
                  diretrizes que, consideradas a relevância e proporcionalidade,
                  devem ser observadas no seu estabelecimento e implementação.
                </p>
              </li>
            </ul>
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec2">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              2. Validade e Disponibilização
            </li>
          </ul>
          <p>
            O conteúdo deste procedimento é de responsabilidade do Diretor de
            Prevenção à Lavagem de Dinheiro e Financiamento ao Terrorismo da{" "}
            <b>OM DTVM</b>, como o responsável pelo seu cumprimento. A gestão
            deste procedimento (elaboração, conformidade, guarda, divulgação,
            controle de atualizações e adesão) faz parte do Programa de
            Conformidade (Compliance) da <b>OM DTVM.</b>
          </p>
          <p>
            Este procedimento é reavaliado e republicado a cada ano, quando
            houver alterações na <b>OM DTVM</b> ou em razão de requerimentos
            legais e/ou de efetividade que justifiquem a sua atualização
            antecipada. A sua existência, assim como suas novas versões são
            aprovadas e comunicadas ao público interno, com assinatura
            eletrônica, através da plataforma Clicksign{" "}
            <a href="https://www.clicksign.com.br/">
              (https://www.clicksign.com.br/){" "}
            </a>{" "}
            e disponibilizada na rede pública interna (Intranet ou Teams) e/ou
            sítio da <b>OM DTVM</b>.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec3">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              3. Objetivo deste Procedimento
            </li>
          </ul>
          <p>
            Implementar procedimentos destinados a conhecer os fornecedores da
            <b>OM DTVM</b>, incluindo procedimentos que assegurem a devida
            diligência na sua identificação, qualificação e classificação, em
            linha com o Capítulo IX da Circular nº 3.978{" "}
            <CustomTooltip
              text="Dispõe sobre a política, os procedimentos e os controles internos a serem adotados pelas instituições autorizadas a funcionar pelo Banco Central do Brasil visando à prevenção da utilização do sistema financeiro para a prática dos crimes de “lavagem” ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento do terrorismo, previsto na Lei nº 13.260, de 16 de março de 2016."
              title="¹²"
            />{" "}
            1, de 23 de janeiro de 2020.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec4">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              4. Programa de Prevenção à Lavagem de Dinheiro
            </li>
          </ul>
          <p>
            O Programa de Prevenção à Lavagem de Dinheiro e Financiamento ao
            Terrorismo da <b>OM DTVM</b> é constituído por 6 pilares: Política
            de Prevenção à Lavagem de Dinheiro e Financiamento ao Terrorismo;
            Avaliação Interna de Riscos; Manuais de Procedimentos Operacionais;
            Avaliação da Efetividade; Treinamento de Prevenção à Lavagem de
            Dinheiro e Financiamento ao Terrorismo e, Auditoria Interna.
          </p>
          <p>
            Os pilares estão em linha com a Lei N 9.6131, de 03 de março de
            1998, Resolução CMN Nº 4.968
            <CustomTooltip
              title="¹⁴"
              text="Dispõe sobre os sistemas de controles internos das instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil."
            />
            , de 25 de novembro de 2021 e, se mostram compatíveis com a
            natureza, porte, complexidade, estrutura, perfil de risco e modelo
            de negócio da <b>OM DTVM.</b>
          </p>
          <p>
            O Programa de Prevenção à Lavagem de Dinheiro é baseado em
            princípios e diretrizes que buscam prevenir e mitigar os riscos
            relacionados à utilização da <b>OM DTVM</b> para práticas de lavagem
            de dinheiro e financiamento do terrorismo.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec5">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              5. Dos Princípios
            </li>
          </ul>
          <p>
            A <b>OM DTVM</b> busca oferecer a todos os seus funcionários,
            colaboradores (pessoas contratadas fora do regime CLT que executam
            atividades em nome da <b>OM DTVM),</b> estagiários, jovens
            aprendizes, correspondentes cambiais e postos de atendimento,
            condições de trabalho adequadas e uma cultura organizacional que
            enfatize o papel de cada agente no processo de Prevenção à Lavagem
            de Dinheiro e Financiamento ao Terrorismo.
          </p>
          <p>
            Neste sentido a<b>OM DTVM</b> está empenhada em conduzir os seus
            negócios de forma consistente com os mais elevados padrões éticos e
            em conformidade com todas as leis, regulamentos e normas vigentes
            aplicáveis, bem como promove uma cultura organizacional que repudia
            qualquer ação que possa contribuir para com a lavagem de dinheiro e
            financiamento do terrorismo e:
          </p>
          <p>
            Não permite que seja associada à lavagem de dinheiro e financiamento
            ao terrorismo, bem como que suas operações sejam utilizadas para
            viabilizar e/ou facilitar tais atos e, conhece e gerencia os riscos
            inerentes e mantém mecanismos de monitoramento e controle para
            diagnosticar e minimizar os riscos referentes à lavagem de dinheiro
            e financiamento do terrorismo relacionado com partes interessadas.
          </p>
          <p>
            O conhecimento de qualquer indício de Lavagem de Dinheiro e
            Financiamento ao Terrorismo ou outro ato ilícito deverá ser
            comunicado à área de Compliance, que é responsável por averiguar as
            informações reportadas e, caso aplicável, após processo de análise,
            comunicar aos órgãos reguladores.
          </p>
          <p>
            A <b>OM DTVM</b>também disponibiliza na rede pública interna
            (Intranet ou Teams) e/ou sítio da <b>OM DTVM</b> um canal de
            comunicação (canal de denúncia) na qual as partes interessadas podem
            reportar anonimamente atos indevidos, referentes a Prevenção à
            Lavagem de Dinheiro e Financiamento ao Terrorismo.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec6">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              6. Das Diretrizes
            </li>
          </ul>
          <p>
            A Diretoria da <b>OM DTVM</b> definiu seu compromisso de aprimorar
            os controles internos e estabelecer as diretrizes para o contínuo
            fortalecimento das práticas de Prevenção à Lavagem de Dinheiro e
            Financiamento ao Terrorismo sendo:
          </p>
          <ul>
            <li>
              Proteção à reputação e a imagem da <b>OM DTVM</b> e não realização
              de operações que possam configurar indícios de ocorrências dos
              crimes de lavagem ou ocultação de bens, direitos e valores ou de
              financiamento do terrorismo;
            </li>
          </ul>
          <p>
            Desenvolvimento, implementação e disseminação de políticas,
            procedimentos e controles internos que promovam a participação
            efetiva da comunidade interna no esforço de prevenir o uso de
            produtos e serviços da <b>OM DTVM</b> para a lavagem de dinheiro e
            financiamento ao terrorismo, contribuindo para a formação de uma
            cultura organizacional de PLD-FT;
          </p>
          <ul>
            <li>
              Adota procedimentos, no processo de identificação, qualificação e
              monitoramento, para identificar se o agente está identificado em
              lista restritiva do Conselho de Segurança das Nações Unidas (CSNU)
              como pessoa ou empresa envolvida em atos terroristas ou no
              financiamento de atos terroristas;
            </li>
          </ul>
          <p>
            Proposição de ações para a constante disseminação da cultura de
            Prevenção à Lavagem de Dinheiro e Financiamento ao Terrorismo e,
            aprimoramento contínuo das políticas, normas e procedimentos de
            gerenciamento de riscos;
          </p>
          <ul>
            <li>
              Disseminação de princípios éticos e regras de conduta aplicáveis
              no cumprimento das regras relacionadas à Prevenção à Lavagem de
              Dinheiro e Financiamento ao Terrorismo;
            </li>
          </ul>
          <p>
            Treinamento adequado e periódico aos funcionários e colaboradores de
            todos os níveis, considerando a atividade desempenhada e a exposição
            ao risco de lavagem de dinheiro e, contemplando ações de
            conscientização e de avaliação de conhecimento;
          </p>
          <ul>
            <li>
              Monitoramento sistêmico de operações visando a coerência nos
              negócios realizados e indícios de lavagem de dinheiro e
              financiamento ao terrorismo em consonância com a “Abordagem
              Baseada em Risco” do GAFI;
            </li>
          </ul>
          <p>
            Avaliação prévia de novos produtos e serviços, bem como da
            utilização de novas tecnologias, tendo em vista o risco de lavagem
            de dinheiro e financiamento ao terrorismo;
          </p>
          <ul>
            <li>
              Realização de auditoria interna anual para a verificação da
              aderência e da adequação das políticas, procedimentos e controles
              internos de PLD-FT;
            </li>
          </ul>
          <p>
            Designação, ao Banco Central do Brasil, de diretor responsável pela
            implementação e cumprimento das medidas relacionadas a PLD-FT,
            encarregado de gerenciar e supervisionar a aplicação das normas
            vigentes e dos princípios e diretrizes aqui estabelecidos e,
          </p>
          <ul>
            <li>
              Condução de forma sigilosa os processos de registro, análise e
              comunicação às autoridades competentes de operações financeiras
              com indícios de lavagem de dinheiro.
            </li>
          </ul>
        </section>

        <section className="mt-5 border p-5" id="sec7">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              7. Papéis e Responsabilidades
            </li>

            <li>
              <p>
                <b>DIRETORIA EXECUTIVA:</b> Responsável por aprovar as
                diretrizes do Manual de Conheça seu Parceiro (KYP) e suas
                respectivas alterações, zelando pela devida implementação dos
                procedimentos e controles regulamentados pela legislação em
                vigor e, assegurar a adoção de melhorias corretivas e
                preventivas para garantir a efetividade do presente Manual.
              </p>
            </li>
            <li>
              <p>
                <b>DIRETOR DE COMPLIANCE:</b> Aprovar o início da relação de
                negócios em caso de insuficiência de informações relativas ao
                processo de qualificação, desde que não haja prejuízo aos
                procedimentos de monitoramento e seleção, bem como aprovar a
                manutenção de Pessoa Exposta Politicamente (PEP) e agentes
                inseridos em monitoramento de especial atenção e, avaliação da
                continuidade do relacionamento relacionada ao descumprimento de
                condições originalmente pactuadas identificadas no processo de
                monitoramento.
              </p>
            </li>
            <li>
              <p>
                <b>AUDITORIA INTERNA:</b> Responsável por avaliar e propor
                medidas para aprimoramento e efetividade do Manual: Conheça Seu
                Fornecedor (KYS) e processos que a <b>OM DTVM</b> estabelece,
                sempre verificando a aderência as regulamentações em vigor e
                aplicabilidade fática.
              </p>
            </li>
            <li>
              <p>
                <b>PLD-FT:</b> Responsável pelo monitoramento tempestivo de
                parceiros e operações, mediante a avaliação da capacidade
                econômico financeira visando coerência nos negócios realizados e
                indícios de lavagem de dinheiro e financiamento ao terrorismo;
                implementar processos e procedimentos para identificação,
                monitoramento e análise de comportamentos, operações e/ou
                transações suspeitas de lavagem de dinheiro e financiamento ao
                terrorismo; reportar ao Diretor de Compliance ou Comitê
                Executivo comportamentos, operações e/ou transações suspeitas
                para deliberação; reportar ao COAF/UIF, após a devida
                deliberação, suspeitas de lavagem de dinheiro e financiamento ao
                terrorismo.
              </p>
            </li>
            <li>
              <p>
                <b>ONBOARDING & BACKGROUND CHECK (CADASTRO):</b> Cumprir as
                normas internas e regulamentos vigentes quanto à Avaliação
                Interna de Riscos (AIR) relacionado aos processos de
                identificação, qualificação e classificação dos procedimentos de
                KYC, KYP, KYE e KYS; definir procedimentos para identificação,
                qualificação e obtenção de dados cadastrais visando a
                identificação e conhecimento do cliente bem como garantir o
                atendimento regulatório; definir controles para validação dos
                dados cadastrais declarados pelos clientes; Garantir que o
                cadastro do cliente esteja em conformidade com o status da
                Receita Federal; Identificar o Beneficiário Final dos clientes
                Pessoa Jurídica e, identificar clientes Pessoas Expostas
                Politicamente (PEP), clientes em listas restritivas, clientes
                que residem em região de fronteira ou possuem nacionalidade em
                país considerado sensível para fins de PLD-FT, ou que apresentam
                enquadramento em profissão de risco ou atividades de risco, que
                seguem procedimento particular com a efetivação do processo
                apenas após autorização explicita do Diretor de Compliance.
              </p>
            </li>
            <li>
              <p>
                <b>COMPLIANCE:</b> Responsável pela elaboração, conformidade,
                guarda, divulgação, controle de atualizações, adesão e promoção
                da cultura organizacional de prevenção à lavagem de dinheiro e
                financiamento ao terrorismo; gerenciamento do sistema de
                normativo interno relacionado à Compliance e Controles Internos
                tais como: avaliação interna de risco (AIR), políticas,
                procedimentos, diretrizes, normas e manuais, instruções
                normativas e recomendações institucionais para conformidade do
                negócio; aderência da instituição ao arcabouço legal, à
                regulamentação infralegal, às recomendações dos órgãos de
                supervisão e aos códigos de ética e de conduta, bem como prestar
                suporte a Diretoria Executiva em assuntos relativos à
                Governança, Risco e Compliance – GRC; atender as demandas e
                eventuais auditorias de órgãos reguladores; análise de situações
                reportados pela comunidade interna e canal de denúncia e,
                realizar os procedimentos relacionados a indisponibilidade de
                ativos estabelecida nas Resoluções do CSNU como: determinação a
                execução de bloqueio dos ativos (indisponibilidade para
                transferir, converter, trasladar, disponibilizar os ativos ou
                deles dispor) de titularidade de cliente pessoa física ou
                jurídica identificada como sancionada pelo Conselho de Segurança
                das Nações Unidas e, comunicação ao Banco Central do Brasil, ao
                Ministério da Justiça e Segurança Pública e ao Conselho de
                Controle de Atividade Financeira (COAF) dessa indisponibilidade
                de ativos ou das tentativas de sua transferência, conforme
                disposto no artigo 4º da Resolução BCB nº 44{" "}
                <CustomTooltip
                  text="Estabelece procedimentos para a execução pelas instituições autorizadas a funcionar pelo Banco Central do Brasil das medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados."
                  title="¹⁵"
                />
                , de 24 de novembro de 2020.
              </p>
            </li>
            <li>
              <b>TECNOLOGIA DA INFORMAÇÃO: </b>Garantir que os sistemas de
              PLD-FT estejam adequadamente em funcionamento, garantindo a
              resolução de eventuais falhas no menor tempo de resposta possível.
            </li>
          </ul>
        </section>
        <section className="mt-5 border p-5" id="sec8">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              8. DEFINIÇÃO DE FORNECEDOR
            </li>
          </ul>
          <p>
            Considera-se parceiro, para aplicação deste manual, o correspondente
            cambial, posto de compra de ouro e demais agentes que executam
            atividades, como contratado nomeado no Banco Central do Brasil
            (BCB), da <b>OM DTVM.</b>
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec9">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              9. DOCUMENTOS SOLICITADOS
            </li>
          </ul>
          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>9.1 BAIXO RISCO</b>
          </h5>
          <p>
            Para iniciar o processo de relação contratual de parceria, é
            obrigatório que o Departamento de Expansão encaminhe à estrutura de
            Onboarding & Background Check toda a documentação pertinente. Isso
            inclui a apresentação de documentos de identificação com foto
            válidos em território nacional, tais como a Carteira de Habilitação
            (CNH), o Registro Geral (RG) ou o Registro no Conselho de Classe, no
            caso de pessoa física. No caso de contratação através da modalidade
            de pessoa jurídica (PJ), é necessário fornecer o Contrato Social e
            documentos de identificação com foto válidos em território nacional,
            como a CNH, o RG ou o Registro no Conselho de Classe do
            representante, procurador e/ou beneficiário final{" "}
            <CustomTooltip
              text="Para fins deste Procedimento, o termo “Beneficiário Final” é amoldado ao Sócio-Administrador e/ou todo aquele que possua 20% (vinte por cento) ou mais das quotas daquela Sociedade."
              title="¹⁶"
            />
          </p>
          <ul>
            <li>
              Em caso de contratação de Correspondente Cambial tipo III, ou
              seja, aquele que realiza “recepção e encaminhamento de propostas
              de operações de câmbio”, de acordo com o inc. III da Resolução CMN
              nº 4.935, de 29 de setembro de 2021, que dispõe sobre a
              contratação de correspondentes no País pelas instituições
              financeiras e pelas demais instituições autorizadas a funcionar
              pelo Banco Central do Brasil.
            </li>
          </ul>
          <p>
            O processo de identificação de parceiros classificados como baixo
            risco, conforme definido pelos critérios estabelecidos na Avaliação
            Interna de Risco (AIR), envolve a obtenção, validação e verificação
            sistêmica da autenticidade das informações de identificação e
            documentos fornecidos pelo prospect. Isso é realizado por meio da
            consulta à Receita Federal (RFB) e ao bureau privado “PH3A” da
            empresa PH3A, utilizando a API (Interface de Programação de
            Aplicação). Durante o processo de identificação, são coletadas, no
            mínimo, as seguintes informações: nome completo e número do Cadastro
            de Pessoa Física (CPF). No caso de pessoa natural, representantes,
            procuradores e/ou beneficiários finais; nome empresarial e número do
            Cadastro de Pessoa Jurídica (CNPJ), no caso de pessoas jurídicas.
          </p>

          <p>
            É importante ressaltar que a coleta, verificação e validação de
            informações estão alinhadas com o perfil de risco do parceiro e a
            natureza da relação contratual de parceria. Durante o processo de
            qualificação, devem ser coletadas, no mínimo, informações que
            permitam a identificação do local de residência e da renda no caso
            de pessoa física, representantes, procuradores ou beneficiários
            finais, e o local da sede ou filial e informações de faturamento no
            caso de pessoas jurídicas.
          </p>

          <p>
            É fundamental mencionar que o procedimento de qualificação também
            inclui a verificação sistêmica da condição do parceiro,
            representante ou procurador, como Pessoa Exposta Politicamente (PEP)
            ou como representante, familiar ou colaborador.
          </p>

          <p>
            Durante a fase de qualificação dos parceiros, as informações
            coletadas são submetidas a verificações e validações por meio de
            consultas a fontes internas e externas (bureaus), além de
            enriquecimento de dados. Os procedimentos de qualificação são
            adaptados à função desempenhada e à extensão da representação. O
            processo de validação das informações é realizado de forma
            sistêmica, utilizando o Sistema Risc da empresa Advice Solutions.
          </p>

          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>9.2 MÉDIO RISCO</b>
          </h5>
          <p>
            Para iniciar o processo de relação contratual de parceria, é
            obrigatório que o Departamento de Expansão encaminhe à estrutura de
            Onboarding & Background Check toda a documentação pertinente. Isso
            incluir a apresentação de documentos de identificação com foto
            válidos em território nacional, tais como a Carteira de Habilitação
            (CNH), o Registro Geral (RG) ou o Registro no Conselho de Classe,
            declaração de imposto de renda e recibo de entrega, no caso de
            pessoa física. No caso de contratação através da modalidade de
            pessoa jurídica (PJ), é necessário fornecer o Contrato Social e
            faturamento dos últimos 12 meses e/ou balanço patrimonial e
            documentos de identificação com foto válidos em território nacional,
            como a CNH, o RG ou o Registro no Conselho de Classe do
            representante, procurador e/ou beneficiário final.
          </p>
          <ul>
            <li>
              Em caso de contratação de Correspondente Cambial tipo II, ou seja,
              aquele que realiza “execução ativa ou passiva de ordem de
              pagamento relativa a transferência unilateral do ou para o
              exterior”, de acordo com o inc. II da Resolução CMN nº 4.935, de
              29 de setembro de 2021, que dispõe sobre a contratação de
              correspondentes no País pelas instituições financeiras e pelas
              demais instituições autorizadas a funcionar pelo Banco Central do
              Brasil.{" "}
            </li>
          </ul>

          <p>
            O processo de identificação de parceiros classificados como médio
            risco, conforme definido pelos critérios estabelecidos na Avaliação
            Interna de Risco (AIR), envolve a obtenção, validação e verificação
            sistêmica da autenticidade das informações de identificação e
            documentos fornecidos pelo prospect. Isso é realizado por meio da
            consulta à Receita Federal (RFB) e ao bureau privado “PH3A” da
            empresa PH3A, utilizando a API (Interface de Programação de
            Aplicação). Durante o processo de identificação, são coletadas, no
            mínimo, as seguintes informações: nome completo e número do Cadastro
            de Pessoa Física (CPF). No caso de pessoa natural, representantes,
            procuradores e/ou beneficiários finais; nome empresarial e número do
            Cadastro de Pessoa Jurídica (CNPJ), no caso de pessoas jurídicas.
          </p>

          <p>
            É importante ressaltar que a coleta, verificação e validação de
            informações estão alinhadas com o perfil de risco do parceiro e a
            natureza da relação contratual de parceria. Durante o processo de
            qualificação, devem ser coletadas, no mínimo, informações que
            permitam a identificação do local de residência e da renda no caso
            de pessoa física, representantes, procuradores ou beneficiários
            finais, e o local da sede ou filial e informações de faturamento no
            caso de pessoas jurídicas.
          </p>

          <p>
            É fundamental mencionar que o procedimento de qualificação também
            inclui a verificação sistêmica da condição do parceiro,
            representante ou procurador, como Pessoa Exposta Politicamente (PEP)
            ou como representante, familiar ou colaborador.
          </p>

          <p>
            Durante a fase de qualificação dos parceiros, as informações
            coletadas são submetidas a verificações e validações por meio de
            consultas a fontes internas e externas (bureaus), além de
            enriquecimento de dados. Os procedimentos de qualificação são
            adaptados à função desempenhada e à extensão da representação. O
            processo de validação das informações é realizado de forma
            sistêmica, utilizando o Sistema Risc da empresa Advice Solutions.
          </p>

          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>9.3 ALTO RISCO</b>
          </h5>
          <p>
            Para iniciar o processo de relação contratual de parceria, é
            obrigatório que o Departamento de Expansão encaminhe à estrutura de
            Onboarding & Background Check toda a documentação pertinente. Isso
            incluir a apresentação de documentos de identificação com foto
            válidos em território nacional, tais como a Carteira de Habilitação
            (CNH), o Registro Geral (RG) ou o Registro no Conselho de Classe,
            declaração de imposto de renda e recibo de entrega, no caso de
            pessoa física. No caso de contratação através da modalidade de
            pessoa jurídica (PJ), é necessário fornecer o Contrato Social e
            faturamento dos últimos 12 meses e/ou balanço patrimonial e
            documentos de identificação com foto válidos em território nacional,
            como a CNH, o RG ou o Registro no Conselho de Classe do
            representante, procurador e/ou beneficiário final, bem como
            declaração de imposto de renda de seus sócios/representantes legais.{" "}
          </p>
          <ul>
            <li>
              Em caso de contratação de Correspondente Cambial tipo I, ou seja,
              aquele que realiza “compra e venda de moeda estrangeira em
              espécie, cheque ou cheque de viagem, bem como carga de moeda
              estrangeira em cartão pré-pago”, de acordo com o inc. I da
              Resolução CMN nº 4.935, de 29 de setembro de 2021, que dispõe
              sobre a contratação de correspondentes no País pelas instituições
              financeiras e pelas demais instituições autorizadas a funcionar
              pelo Banco Central do Brasil, deverá, de forma complementar,
              apresentar o Selo de Conformidade Abracam (Associação Brasileira
              de Câmbio devidamente vigente.
            </li>
          </ul>
          <p>
            O processo de identificação de parceiros classificados como alto
            risco, conforme definido pelos critérios estabelecidos na Avaliação
            Interna de Risco (AIR), envolve a obtenção, validação e verificação
            sistêmica da autenticidade das informações de identificação e
            documentos fornecidos pelo prospect. Isso é realizado por meio da
            consulta à Receita Federal (RFB) e ao bureau privado “PH3A” da
            empresa PH3A, utilizando a API (Interface de Programação de
            Aplicação). Durante o processo de identificação, são coletadas, no
            mínimo, as seguintes informações: nome completo e número do Cadastro
            de Pessoa Física (CPF). No caso de pessoa natural, representantes,
            procuradores e/ou beneficiários finais; nome empresarial e número do
            Cadastro de Pessoa Jurídica (CNPJ), no caso de pessoas jurídicas.
          </p>
          <p>
            É importante ressaltar que a coleta, verificação e validação de
            informações estão alinhadas com o perfil de risco do parceiro e a
            natureza da relação contratual de parceria. Durante o processo de
            qualificação, devem ser coletadas, no mínimo, informações que
            permitam a identificação do local de residência e da renda no caso
            de pessoa física, representantes, procuradores ou beneficiários
            finais, e o local da sede ou filial e informações de faturamento no
            caso de pessoas jurídicas.
          </p>
          <p>
            É fundamental mencionar que o procedimento de qualificação também
            inclui a verificação sistêmica da condição do parceiro,
            representante ou procurador, como Pessoa Exposta Politicamente (PEP)
            ou como representante, familiar ou colaborador.
          </p>
          <p>
            Durante a fase de qualificação dos parceiros, as informações
            coletadas são submetidas a verificações e validações por meio de
            consultas a fontes internas e externas (bureaus), além de
            enriquecimento de dados. Os procedimentos de qualificação são
            adaptados à função desempenhada e à extensão da representação. O
            processo de validação das informações é realizado de forma
            sistêmica, utilizando o Sistema Risc da empresa Advice Solutions.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec10">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              10. CRITÉRIOS DA CLASSIFICAÇÃO DE RISCO
            </li>
          </ul>
          <p>
            A <b>OM DTVM </b> adota uma Abordagem Baseada em Risco (ABR), com o
            objetivo de assegurar que as medidas adotadas para prevenir ou
            mitigar os riscos de Lavagem de Dinheiro e Financiamento do
            Terrorismo, sejam proporcionais aos riscos identificados no processo
            de início da contratação. Os sistemas contratados oferecem eficiente
            controle, subsídios para análise e monitoramento compatível com cada
            perfil de risco. Classificar o risco envolve a checagem e tratamento
            do risco reputacional, qualquer risco relacionado a lavagem de
            dinheiro e financiamento do terrorismo e, risco da atividade
            exercida. Neste sentido, foram definidas 3 categorias de risco que
            identificam o parceiro/prestador de serviço:
          </p>
          <p>
            Refere-se aos diversos tipos de exposição que os parceiros e
            prestadores de serviços se enquadram devido a sua atividade
            exercida, avaliação reputacional segundo os critérios parametrizados
            no sistema Risc e, calculado através da calculadora de risco,
            conforme escala abaixo:
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  RISCO
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  ESCALA DE PONTOS
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["INACEITÁVEL", "30 ATÉ 99"],
                ["ALTO", "10 ATÉ 29"],
                ["MÉDIO", "05 ATÉ 09"],
                ["BAIXO", "00 ATÉ 04"],
              ].map(([risco, escala], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {risco}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {escala}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            Os fatores considerados para o cálculo sistêmico através do Sistema
            RISC da empresa Advice Compliance Solutions são:
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  DESCRIÇÃO DA PONTUAÇÃO
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  PONTUAÇÃO
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["LISTA CSNU", 30],
                ["CPF/CNPJ INATIVO", 30],
                ["PEP – PESSOA EXPOSTA POLITICAMENTE", 10],
                ["LISTA DE SANÇÕES", 10],
                ["CVM – PROCESSOS SANCIONADORES", 10],
                ["ANTECEDENTE CRIMINAL", 10],
                ["CIDADE FRONTEIRA", 10],
                ["INEXISTÊNCIA DE BENEFICIÁRIO FINAL", 10],
                ["MULTAS AMBIENTAIS", 5],
                ["LISTA RESTRITIVA", 5],
                ["PROCESSOS JUDICIAIS", 5],
                ["MÍDIA NEGATIVA", 5],
              ].map(([descricao, pontuacao], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {descricao}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {pontuacao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            Os fatores considerados para o cálculo em relação às atividades
            exercidas são:
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  DESCRIÇÃO
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "center",
                  }}
                >
                  PONTUAÇÃO
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["CORRESPONDENTE CAMBIAL: TIPO 31", 1],
                ["CORRESPONDENTE CAMBIAL: TIPO 22", 5],
                ["CORRESPONDENTE CAMBIAL: TIPO 13", 10],
                ["POSTO DE COMPRA DE OURO", 10],
              ].map(([descricao, pontuacao], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {descricao}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {pontuacao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>O sistema, após identificar e varrer todas as bases e fontes de consulta, aponta um risco inicial que se refere à soma da pontuação de todos os itens identificados, com base em suas respectivas pontuações e, após a análise manual do analista da estrutura de Onboarding & Background Check validando se, de fato aquelas informações se tratam de positivo e/ou falso positivo, identificando e classificando no próprio sistema, como: “SIM” para itens positivos e verídicos e, “NÃO” para itens falso positivos/inverídicos. E, ao final, após o analista finalizar o relatório, o sistema realizará uma somatória de todos os itens classificados como “SIM”, incluindo a atividade a ser exercida no vínculo, se funcionário, parceiro ou prestador de serviços e gerará o risco final analisado.</p>

          <p>Neste sentido foram definidas, 3 (três) categorias de risco:</p>

          <h5><b>ALTO RISCO</b></h5>
          <p>Correspondente cambial que realiza a operação de compra e venda de moeda estrangeira em espécie, cheque ou cheque de viagem, bem como carga de moeda estrangeira em cartão pré-pago, de acordo com a Resolução CMN 4.935, de 29 de setembro de 2021, que dispõe sobre a contratação de correspondentes no País pelas instituições financeiras e pelas demais instituições autorizadas a funcionar pelo Banco Central do Brasil; posto de compra de ouro (PCO) que realiza a aquisição de ouro.</p>
          <p>Em que pese ao risco reputacional, leva-se em consideração: se possui envolvimento, não transitado em julgado, com crimes ambientais relacionados a aquisição ilegal de ouro e/ou lavagem de dinheiro e financiamento ao terrorismo; cliente classificado como Pessoa Exposta Politicamente (PEP); classificado como Organização Não Governamental (ONG); multa ambiental acima de R$500.000,00 (quinhentos mil reais); pessoa jurídica, sem identificação de beneficiário final; pessoa relacionada em lista de sanções internacionais.</p>

          <h5><b>MÉDIO RISCO</b></h5>
          <p>Correspondente cambial que realiza a execução ativa ou passiva de ordem de pagamento relativa à transferência unilateral do ou para o exterior, de acordo com a Resolução CMN 4.935, de 29 de setembro de 2021, que dispõe sobre a contratação de correspondentes no País pelas instituições financeiras e pelas demais instituições autorizadas a funcionar pelo Banco Central do Brasil.</p>
          <p>Em que pese ao risco reputacional, leva-se em consideração se possui envolvimento, transitado em julgado, com crimes não relacionados a aquisição ilegal de ouro e/ou lavagem de dinheiro e financiamento ao terrorismo; multa ambiental entre R$100.000,00 (cem mil reais) e R$500.000,00 (quinhentos mil reais); mídia negativa relacionada a crimes ambientais, aquisição ilegal de ouro e/ou lavagem de dinheiro e financiamento ao terrorismo; localizado em regiões de fronteira ou de extração mineral; relacionado em lista restritiva nacional ou interna.</p>

          <h5><b>BAIXO RISCO</b></h5>
          <p>Correspondente cambial que realiza a recepção e encaminhamento de propostas de operações de câmbio, de acordo com a Resolução CMN 4.935, de 29 de setembro de 2021, que dispõe sobre a contratação de correspondentes no País pelas instituições financeiras e pelas demais instituições autorizadas a funcionar pelo Banco Central do Brasil.</p>
          <p>Em que pese ao risco reputacional, leva-se em consideração se possui envolvimento, não transitado em julgado, com crimes não relacionados a aquisição ilegal de ouro e/ou lavagem de dinheiro e financiamento ao terrorismo; multa ambiental até R$100.000,00 (cem mil reais).</p>
        </section>

        <section className="mt-5 border p-5" id="sec11">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              11. ESPECIFICIDADES PARA CADA GRUPO DE RISCO
            </li>
          </ul>
          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>11.1. PARCEIRO ENQUADRADO COMO “RISCO BAIXO”</b>
          </h5>
          <p>
          Para fins de atualização de Parceiros enquadrados como “Risco Baixo”, o período de atualização deve obedecer a métrica de 18 (dezoito) meses ao máximo, podendo ser necessário o encurtamento do prazo se determinado por Órgão Regulatório.
          </p>

          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>11.2. PARCEIRO ENQUADRADO COMO “RISCO MÉDIO”</b>
          </h5>
          <p>
          Para fins de atualização de Parceiros enquadrados como “Risco Médio”, o período de atualização deve obedecer a métrica de 12 (doze) meses ao máximo, podendo ser necessário o encurtamento do prazo se determinado por Órgão Regulatório.
          </p>

          <h5 className="text-decoration-underline mb-2 mt-4">
            {" "}
            <b>11.3. PARCEIRO ENQUADRADO COMO “RISCO ALTO”</b>
          </h5>
          <p>
          Em atendimento ao disposto no art. 10, § 3º da Circular nº 3.978/20 do Banco Central do Brasil, a OM DTVM estabelece e implementa diligências adicionais para os Fornecedores e Prestadores de Serviços enquadrados como de “Risco Alto”, sendo tais:
          </p>
          <p><b>1) Realização de Due Diligence aprofundada (Enhanced Due Diligence – EDD),</b> com análise documental detalhada e validação de informações com fontes independentes.</p>

          <p><b>2) Solicitação de documentação complementar,</b> como:</p>
          <ul>
          <li>Contratos sociais atualizados e alterações contratuais;</li>
          <li>Comprovantes de endereço e atividade econômica;</li>
          <li>Demonstrações financeiras auditadas;</li>
          <li>Certidões negativas criminais e fiscais dos sócios e administradores.</li>
          </ul>

          <p><b>3) Entrevista direta com representantes legais ou beneficiários finais</b>  (se necessário), a fim de esclarecer estruturas societárias complexas, origens de recursos e objetivos da relação comercial.</p>

          <p><b>4) Consulta ativa em listas internacionais de sanções e PEPs (Pessoas Politicamente Expostas),</b> a qual deverá ser realizada através da inclusão destes no sistema E-GUARDIAN, a fim de monitoramento contínuo de suas atividades.</p>

          <p><b>5) Avaliação da exposição ao risco jurisdicional,</b> em casos de atuação ou sede em países classificados como de alto risco ou com deficiências estratégicas em PLD/FT. </p>

          <p><b>6) Inclusão de cláusulas contratuais específicas de compliance,</b> prevendo:</p>
          <ul>
          <li>Obrigatoriedade de manutenção de programa de integridade;</li>
          <li>Cooperação em eventuais investigações internas;</li>
          <li>Regras anticorrupção; e</li>
          <li>Rescisão contratual por descumprimento de normas de PLD/FT.</li>
          </ul>

          <p><b>7) Submissão à unanime aprovação da contratação/renovação pelo Departamento de Compliance e Corpo Diretor da OM DTVM.</b></p>
          <p>Essas medidas visam assegurar que a contratação de fornecedores e prestadores de serviços esteja alinhada com os princípios de integridade, transparência e prevenção a ilícitos, conforme os padrões regulatórios e de boas práticas do mercado.</p>
          <p>Para fins de atualização de Parceiros enquadrados como “Risco Alto”, o período de atualização deve obedecer a métrica de 6 (seis) meses ao máximo, podendo ser necessário o encurtamento do prazo se determinado por Órgão Regulatório.</p>
        </section>

        <section className="mt-5 border p-5" id="sec12">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              12. SISTEMAS UTILIZADOS
            </li>
          </ul>
          <p>
          A confrontação sistematicamente, através do uso de API (Application Programming Interface – Interface de Programação de Aplicação) de nossos sistemas internos com a Receita Federal do Brasil (RFB) visa identificar se o Cadastro de Pessoas Físicas (CPF), no caso de pessoa natural e se o Cadastro Nacional de Pessoa Jurídica (CNPJ), no caso de pessoa jurídica, se mostram inativos e, com o bureau privado da empresa Advice Solutions, se o CPF, CNPJ e nome, no caso de estrangeiro desobrigado de CPF, se relacionam com Pessoa Exposta Politicamente (PEP) ou se, qualquer um dos nomes se encontram na Lista de Sanções do Conselho de Segurança das Nações Unidas (CSNU).
          </p>
          <p>
          A depender do perfil de risco identificado e evolução da relação de negócios, a estrutura de Onboarding & Background Check (Cadastro) realizará avaliação mais reforçada para situações de maior risco que contemplarão o uso do Relatório Reputacional – RISC da Empresa Advice Compliance Solutions que, adicionalmente, avalia processos judiciais no TRF, TCU, STF, TJ, JF, STJ, CNJ e MPF, mídias negativa presentes na internet, listas restritivas nacionais e internacionais e listas de sanções nacionais e internacionais
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec13">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              13. GUARDA DE DOCUMENTOS
            </li>
          </ul>
          <p>
            A<b>OM DTVM</b>  através de seus funcionários, colaboradores (pessoas contratadas fora do regime CLT que executam atividades em nome da <b>OM DTVM</b>), estagiários, jovens aprendizes, correspondentes cambiais e postos de atendimento garantem o sigilo de todas as informações e de todos os documentos relacionados com suas operações de ouro e câmbio por 10 anos.
          </p>

        </section>
        <section className="mt-5 border p-5" id="sec14">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              14. SANÇÕES ADMINISTRATIVAS
            </li>
          </ul>
          <p>
          Os funcionários, colaboradores (pessoas contratadas fora do regime CLT que executam atividades em nome da <b>OM DTVM</b>), estagiários, jovens aprendizes, correspondentes cambiais e postos de atendimento da <b>OM DTVM</b> que não cumprirem por negligência, culpa ou dolo os requerimentos deste Procedimento, dependendo da gravidade da falta, serão advertidos oficiosamente, advertidos formalmente, suspensos temporariamente ou ter seu contrato denunciado.
          </p>

        </section>
      </section>
    </article>
  );
}

const CustomTooltip = (props: { title: string; text: string }) => {
  return (
    <>
      <Tooltip title={props.text} placement="top-start">
        <sup>
          <Button style={{ margin: 0, padding: 0, minWidth: "0px" }}>
            {props.title}
          </Button>
        </sup>
      </Tooltip>
    </>
  );
};
